import * as actionTypes from "../actions/actionTypes";

const intialState = {
  isLoading: false,
  error: "",
  dashboard: "",
};

const getDashBoardStart = (state) => {
  return {
    ...state,
    isLoading: true,
    dashboard: "",
    error: "",
  };
};

const getDashBoardSuccess = (state, data) => {
  return {
    ...state,
    dashboard: data,
    isLoading: false,
    error: "",
  };
};

const getDashBoardFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};
//distributor dashboard
const getDistributorDashBoardStart = (state) => {
  return {
    ...state,
    isLoading: true,
    dashboard: "",
    error: "",
  };
};

const getDistributorDashBoardSuccess = (state, data) => {
  return {
    ...state,
    dashboard: data,
    isLoading: false,
    error: "",
  };
};

const getDistributorDashBoardFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

const dashboardReducer = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DASHBOARD_START:
      return getDashBoardStart(state);
    case actionTypes.GET_DASHBOARD_SUCCESS:
      return getDashBoardSuccess(state, action.data);
    case actionTypes.GET_DASHBOARD_FAIL:
      return getDashBoardFail(state, action.err);

      case actionTypes.GET_DASHBOARD_START:
        return getDistributorDashBoardStart(state);
      case actionTypes.GET_DASHBOARD_SUCCESS:
        return getDistributorDashBoardSuccess(state, action.data);
      case actionTypes.GET_DASHBOARD_FAIL:
        return getDistributorDashBoardFail(state, action.err);
        
    // case actionTypes.LOGIN_RESETTER : return {...state}
    default:
      return state;
  }
};

export default dashboardReducer;
